import {useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Input, Modal, notification, Row,Col, Table, Typography, Tooltip, Space, DatePicker } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";

import {
  GlobalTableStyle,
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import { ColumnsType } from "antd/es/table";
import pageSize from "../../../constants/pageSize";
import { useDeleteRiderByIdMutation, useGetAllRiderQuery } from "../../../feature/user/userApiSlice";
import { DeleteButton, ViewDetailsButton, RefreshButton, PrimaryButton } from "../../styled/Button.styled";
import constants from "../../../constants";
import { IUser } from "../../../types/user";
import Card from "../../countCard/Card";
import { fullName } from "../../../utils/fullName";
const defaultImage: string = require("../../../assets/logo/defaultImage.svg").default;

function User() {
  const navigate = useNavigate();
  const routerLocation = useLocation();
   const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(pageSize);
  const { data, isLoading,refetch} = useGetAllRiderQuery();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [deleteRiderById] = useDeleteRiderByIdMutation();
  const { confirm } = Modal;
  const [nameValue, setNameValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [registeredValue, setRegisteredValue] = useState("");
  const [downloadFrom, setDownloadFrom] = useState<Dayjs | null>(null);
  const [downloadTo, setDownloadTo] = useState<Dayjs | null>(null);

  const handleDownloadCsv = () => {
    if (!downloadFrom || !downloadTo) {
      notification.error({
        message: "Select month/year range",
        description: "Please select a from and to month/year to download the list.",
        placement: "bottomLeft",
      });
      return;
    }

    const fromDate = downloadFrom.startOf("month");
    const toDate = downloadTo.endOf("month");

    const filteredUsers = (data?.data.content || []).filter((user) => {
      const registeredOn = dayjs(user.createdAt);
      if (!registeredOn.isValid()) {
        return true;
      }
      return registeredOn.isAfter(fromDate.subtract(1, "second")) && registeredOn.isBefore(toDate.add(1, "second"));
    });

    if (filteredUsers.length === 0) {
      notification.info({
        message: "No users found",
        description: "No users registered in the selected month/year range.",
        placement: "bottomLeft",
      });
      return;
    }

    const headers = [
      "First Name",
      "Last Name",
      "Phone",
      "Email",
      "Home Address",
      "Work Address",
      "Registered On",
      "Registered Time",
    ];
    const rows = filteredUsers.map((user) => [
      user.firstName || user.lastName ? user.firstName || "" : user.phoneNumber || "",
      user.lastName || "",
      user.phoneNumber || "",
      user.email || "",
      user.homeAddress || "",
      user.officeAddress || "",
      dayjs(user.createdAt).isValid() ? dayjs(user.createdAt).format("DD-MM-YYYY") : "",
      dayjs(user.createdAt).isValid() ? dayjs(user.createdAt).format("HH:mm") : "",
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `users_${fromDate.format("MMM-YYYY")}_to_${toDate.format("MMM-YYYY")}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const showConfirm = (id: number) => {
    confirm({
      title: "Do You Want To Delete User?",
      onOk() {
        onDelete(id);
      },
      onCancel() { },
    });
  };

  const onDelete = (id: number) => {
    deleteRiderById(id)
      .unwrap()
      .then(() => {
        notification.success({
          message: "Sucessfully Deleted!",
          placement: "bottomLeft",
        });
      })
      .catch((error) =>
        notification.error({
          message: "Error!",
          description: error.data.message,
          placement: "bottomLeft",
        })
      );
  };
  const columns: ColumnsType<IUser> = [
    {
      key: "userName",
      // ellipsis: true,
      width: "30%",
      title: (
        <div>
          <Typography.Text> Name</Typography.Text>
          <div>
          <Input.Search
            onChange={(e) => {
              setNameValue(e.target.value);
            }}
            placeholder="Search here"
            />
            </div>
        </div>
      ),
      filteredValue: [nameValue],
      onFilter: (value: any, record) => {
        return record.firstName
          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (_: any, record) => {
        return (
          <>
            <Row>
              <Col><img
                alt="user"
                src={`${constants.baseImgUrl}${record.userImage}` }
                onError={(e) => {
                  (e.target as HTMLSourceElement).src= defaultImage
               }}
              style={{ height: "48px", width: "48px", borderRadius: "30px" }}
            /></Col>
              <Col style={{marginTop:"0.8rem"}}>{record.firstName ? fullName(record.firstName, record.lastName) : record.phoneNumber}</Col>
            </Row>
            
            
          </>
        );
      },

    },
    {
      key: "email",
      title: (
        <div>
          <Typography.Text>Email</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setEmailValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [emailValue],
      onFilter: (value: any, record) => {
        return record.email
          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (value: any, record) => {
        return record?.email ? record.email :"-------";
      },
      dataIndex: "email",
    },

    {
      key: "phoneNumber",
      title: (
        <div>
          <Typography.Text>Phone</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setPhoneValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [phoneValue],
      onFilter: (value: any, record) => {
        return record.phoneNumber

          .toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (value: any, record) => {
        return record.phoneNumber;
      },
      dataIndex: "phoneNumber",
    },
    {
      key: "registeredOn",
      title: (
        <div>
          <Tooltip 
            title="These are the dates when the user registered"
            color="#414040be"
          >
            <Typography.Text>Registered On</Typography.Text>
          </Tooltip>
          <Input.Search
            onChange={(e) => {
              setRegisteredValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [registeredValue],
      onFilter: (value: any, record) => {
        const date = new Date(record.createdAt);
        const formatted = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        return formatted.toLowerCase().includes(value?.toLowerCase());
      },
      render: (_, record) => {
        const date = new Date(record.createdAt);
        const formatted = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        return formatted;
      },
      dataIndex: "createdAt",
    },
    {
      key: "registeredtime",
      title: (
        <div>
          <Tooltip
            title="These are the times when the user registered"
            color="#414040be"
          >
            <Typography.Text>Registered Time</Typography.Text>
          </Tooltip>
          <Input.Search
            placeholder="Search here"
            onChange={(e) => setRegisteredValue(e.target.value)}
          />
        </div>
      ),
      filteredValue: [registeredValue],
      onFilter: (value: any, record) => {
        const time = new Date(record.createdAt).toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });

        return time.includes(String(value));
      },
      render: (_, record) =>
        new Date(record.createdAt).toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
      dataIndex: "createdAt",
    },
    {
      key: "viewDetails",
      dataIndex: "viewDetails",
      render: (_, record) => (
        <ViewDetailsButton onClick={() => openUserDetails(record.id)}>
          View Details
        </ViewDetailsButton>
      ),
    },
    {
      key: "deleteButton",
      render: (_, record) => (
        <DeleteButton onClick={() => showConfirm(record.id)} />
      ),
    },
  ];

  const openUserDetails = (id: number) => {
   navigate(`edit/${id}?page=${currentPage}`);
  };
  const sum = data?.data.totalElements ?? data?.data.content.length;
  
  useEffect(() => {
    refetch(); 
  }, [refetch]);

  useEffect(() => {
      // Restore page from URL when component mounts or when navigating back
      const urlParams = new URLSearchParams(routerLocation.search);
      const pageFromUrl = urlParams.get('page');
      if (pageFromUrl) {
        setCurrentPage(parseInt(pageFromUrl, 10));
      }
    }, [routerLocation.search]);
  
  return (
    <>
      <Row justify="space-between" align="middle" className="button-bottom-margin">
        <Card sum={sum} text="Users" />
        <Space align="end">
          <div
            style={{
              borderRadius: "8px",
              padding: "6px 12px",
              background: "#cbe3f7",
            }}
          >
            <Typography.Text
              style={{ display: "block", fontSize: "12px", color: "#3e4685", marginBottom: "4px" }}
            >
              Export/Download user details for a month/year range
            </Typography.Text>
            <Space>
              <DatePicker
                picker="month"
                placeholder="From month"
                value={downloadFrom}
                onChange={(date) => setDownloadFrom(date)}
                style={{ height: "3rem", fontSize: "20px" }}
              />
              <DatePicker
                picker="month"
                placeholder="To month"
                value={downloadTo}
                onChange={(date) => setDownloadTo(date)}
                style={{ height: "3rem", fontSize: "20px" }}
              />
              <PrimaryButton
                icon={<DownloadOutlined />}
                onClick={handleDownloadCsv}
              >
                Download
              </PrimaryButton>
            </Space>
          </div>
          <RefreshButton
            loading={isRefreshing}
            onClick={async () => {
              setIsRefreshing(true);
              await refetch();
              setIsRefreshing(false);
            }}
          />
        </Space>
      </Row>
      <LightBlueContainer>
        <WhiteContainer>
          <GlobalTableStyle>
            <Table<IUser>
              loading={isLoading}
              columns={columns}
              dataSource={data?.data.content}
              pagination={{
                pageSize: currentPageSize,
                current: currentPage,
                pageSizeOptions: ["8", "10", "20", "50", "100"],
                onChange: (page, size) => {
                  setCurrentPage(page);
                  setCurrentPageSize(size);
                },
              }}
              rowKey="id"
            />
          </GlobalTableStyle>
        </WhiteContainer>
      </LightBlueContainer>
    </>
  );
}
export default User;